import { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { CommodityWaybillsDetailFooter } from "./CommodityWaybillsDetailFooter";
import { useTranslation } from "react-i18next";
import CommodityWaybillsDetailMain from "./CommodityWaybillsDetailMain";
import CommodityWaybillsDetailProducts from "./CommodityWaybillsDetailProducts";
import CommodityWaybillsDetailAdditional from "./CommodityWaybillsDetailAdditional";
import { ICommodityWaybillsModel } from "../models/ICommodityWaybillsModel";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFTab } from "src/components/Shared/NewForms/NFTab";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { useFetchCommodityWaybills } from "../hooks/fetchDocument";
interface IProps {
  id?: string;
}

export const CommodityWaybillsDetail = ({ id }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Commodity Waybills");
  // const [showOnPost, setShowOnPost] = useState(true);
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ICommodityWaybillsModel>({
    mode: "onTouched"
  });;

  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchCommodityWaybills({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Information"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* {isButtonShown && ( */}
        {/* <DocumentModalViewHeader
          showOnPost={showOnPost}
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onSendToRs={handleSubmit((data) => handleFormSubmitLocal("rs", data))}
          onActivate={handleSubmit((data) => handleFormSubmitLocal("activate", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
          {/*<DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel}*/}
        {/*                              fileName={fileName} setFileName={setFileName}/>*/}
        </DocumentDetailViewToolbar>
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <CommodityWaybillsDetailMain />
        </NFTabContainer>
        {/*  */}
        <NFTabContainer index={1} currentIndex={tabIndex}>
          <CommodityWaybillsDetailProducts />
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <NFormTable fieldArray={"commodityWaybillInformations"}>
              <NFTextInput fieldName={"document"} title={"document"} />
              <NFTextInput fieldName={"name"} title={"name"} />
              <NFDateInput title="Date" fieldName="date" />
            </NFormTable>
          </div>
        </NFTabContainer>
        <NFTabContainer index={3} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <CommodityWaybillsDetailAdditional />
          </div>
        </NFTabContainer>
      </div>
      <CommodityWaybillsDetailFooter />
    </FormProvider>
  );
};
